import { FormGroup } from '@angular/forms';
import { GroupMarketingPreferencesForm } from './group-marketing-preferences-form.interface';

export type GroupMarketingPreferencesFormValue = ReturnType<
  FormGroup<GroupMarketingPreferencesForm>['getRawValue']
>;
